export const Views = Object.freeze({
  email: "email",
  options: "options",
  phone: "phone",
  sms: "sms",
});
